export const GET_SERVICES_DATA = 'GET_SERVICES_DATA';
export const getProfileData = payload => ({ type: GET_SERVICES_DATA, payload });

export const SET_SERVICES_DATA = 'SET_SERVICES_DATA';
export const setProfileData = payload => ({ type: SET_SERVICES_DATA, payload });